import React from 'react';
import * as superAppMenuInfra from '#packages/superAppMenuInfra';
import { connectWithScope, type InferComponentProps } from '#packages/apilib';
import promoteBi from '../common/bi/promoteBi';
import { biLogger } from '#packages/util';
import { PromoteScope } from '../../../scope';

import superApp from '../../superApp';

export interface OwnProps {}

type PromoteMenuPanelProps = InferComponentProps<
  typeof mapStateToProps,
  typeof mapDispatchToProps,
  OwnProps
>;

class PromoteMenuPanel extends React.Component<PromoteMenuPanelProps> {
  getSuperApp() {
    return superApp.getPromoteSuperApp({
      isMailchimpUser: this.props.isMailchimpUser,
    });
  }

  render() {
    return (
      <superAppMenuInfra.superAppPanel
        panelClass="promote-panel"
        superApp={this.getSuperApp()}
        tabsWidth={201}
      />
    );
  }
}

const mapStateToProps = (scope: PromoteScope) => {
  const biBaseParams = promoteBi.biUtils.getBiBaseParams(scope);
  const isMailchimpUser = scope.store.getIsMailchimpUser();

  return {
    biBaseParams,
    isMailchimpUser,
  };
};

const mapDispatchToProps = () => ({
  sendBi: (event: any, parameters: object) =>
    biLogger.report({ ...event, ...parameters }),
});

export default connectWithScope(
  () => PromoteScope,
  PromoteMenuPanel,
  mapStateToProps,
  mapDispatchToProps,
);
